<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <dark-Toggler class="d-none d-lg-block" />
      <bookmarks />
    </div>

 
    <b-navbar-nav class="nav align-items-center ml-auto">
      
      <search-bar />
    
      <notification-dropdown />
      <locale />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";
import Bookmarks from "@core/layouts/components/app-navbar/components/Bookmarks.vue";
import Locale from "@core/layouts/components/app-navbar/components/Locale.vue";
import SearchBar from "@core/layouts/components/app-navbar/components/SearchBar.vue";
import CartDropdown from "@core/layouts/components/app-navbar/components/CartDropdown.vue";
import NotificationDropdown from "@core/layouts/components/app-navbar/components/NotificationDropdown.vue";
import UserDropdown from "@core/layouts/components/app-navbar/components/UserDropdown.vue";

import Auth from "@/Apis/Auth";

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    Bookmarks,
    Locale,
    SearchBar,
    DarkToggler,
    CartDropdown,
    NotificationDropdown,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },

  created() {
    this.userData = Auth.USER;
  },
  data() {
    return {
      userData: {},
      avatarText: "",
    };
  },
  methods: {
    logout() {
      Auth.logOut();
      // this.$router.push({ name: "auth-login" });
    },
  },
};
</script>
